export const STORE_INFO_SECTIONS = [
    {
        id: "company-store-details",
        titleKey: "pages.sellerProfile.storeInfo.sections.companyStoreDetails.title",
        hintKey: "pages.sellerProfile.storeInfo.sections.companyStoreDetails.hint",
        jumpKey: "pages.sellerProfile.storeInfo.sections.companyStoreDetails.jumpLabel",
        countsTowardCompleteness: true,
    },
    {
        id: "key-contacts",
        titleKey: "pages.sellerProfile.storeInfo.sections.keyContacts.title",
        hintKey: "pages.sellerProfile.storeInfo.sections.keyContacts.hint",
        jumpKey: "pages.sellerProfile.storeInfo.sections.keyContacts.jumpLabel",
        countsTowardCompleteness: true,
    },
    {
        id: "customer-support",
        titleKey: "pages.sellerProfile.storeInfo.sections.customerSupport.title",
        hintKey: "pages.sellerProfile.storeInfo.sections.customerSupport.hint",
        jumpKey: "pages.sellerProfile.storeInfo.sections.customerSupport.jumpLabel",
        countsTowardCompleteness: true,
    },
    {
        id: "perks-loyalty-benefits",
        titleKey: "pages.sellerProfile.storeInfo.sections.perksLoyaltyBenefits.title",
        hintKey: "pages.sellerProfile.storeInfo.sections.perksLoyaltyBenefits.hint",
        jumpKey: "pages.sellerProfile.storeInfo.sections.perksLoyaltyBenefits.jumpLabel",
        countsTowardCompleteness: false,
    },
];
